import React from 'react'
import { Route } from 'react-router'
//school specific pages
import Splitter from '../helpers/Splitter'

const SchoolStudentsManagement = Splitter(() =>
  import('../components/school/StudentsManagement')
)

export const SchoolStudentManagementRoute = (
  <Route path="school-students/:schoolId" component={SchoolStudentsManagement} />
)



// WEBPACK FOOTER //
// ./src/routes/schoolRoutes.js